"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Chevron = _interopRequireDefault(require("../../Icons/Chevron"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n\ttransition: transform 300ms ease;\n\ttransform: ", ";\n\tcolor: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var ChevronSpinner = (0, _styledComponents.default)(_Chevron.default)(_templateObject(), function (props) {
  return "rotate(" + props.rotate + "deg)";
}, _colors.default.secondary);
ChevronSpinner.displayName = 'ChevronSpinner';

var Chevron = function Chevron(_ref) {
  var expanded = _ref.expanded,
      props = _objectWithoutPropertiesLoose(_ref, ["expanded"]);

  return _react.default.createElement(ChevronSpinner, _extends({
    rotate: expanded ? -180 : 0,
    size: 15
  }, props));
};

Chevron.displayName = 'Chevron';
Chevron.propTypes = {
  expanded: _propTypes.default.bool.isRequired
};
var _default = Chevron;
exports.default = _default;